export default __webpack_public_path__ + "static/media/iconesCompradores.773cf803.png";